import {
  LoyaltyProgramState,
  useLoyaltyProgramContext,
} from "../context/LoyaltyProgramContext";

export type { LoyaltyProgramState };

/**
 * Per-location loyalty program status. Reads the app-root
 * LoyaltyProgramProvider (fetched once per location at boot, refetched on
 * location switch) instead of firing a settings GET per consuming surface —
 * so every consumer (Rewards page, client drawer, client form, checkout)
 * sees the same boot-time state and any refresh() is visible everywhere.
 *
 * Without a mounted provider (isolated unit tests) it returns an inert
 * "feature locked" state.
 */
export function useLoyaltyProgram(): LoyaltyProgramState {
  return useLoyaltyProgramContext();
}

export default useLoyaltyProgram;
